/**
 * ADR-0185 Addendum 3 — the board-view manifest. Importing this module
 * registers every shipped view with the registry; the shell imports it for
 * that side effect and nothing else. A new archetype's view is one new
 * directory plus one registration line here — the shell stays untouched.
 */
import { registerBoardView, registerNextUpView } from "../viewRegistry.js";
import { MACHINE_SCHEDULING_TEMPLATE_ID, MachineSchedulingView } from "./machineScheduling/MachineSchedulingView.js";
import { NextUpFace } from "./machineScheduling/NextUpFace.js";

registerBoardView(MACHINE_SCHEDULING_TEMPLATE_ID, MachineSchedulingView);
registerNextUpView(MACHINE_SCHEDULING_TEMPLATE_ID, NextUpFace);
